<template>
  <div>
    <v-row class="mt-4 mb-8 pl-2" align="center">
      <v-icon large>mdi-clipboard-text-search</v-icon>
      <h2 class="text-h5 pl-2">Módulo Pesquisa de Satisfação</h2>
    </v-row>
    <v-row no-gutters>
      <div class="text-h6">Cadastro de Pesquisa de Satisfação</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoCadastroPesquisaSatisfacao"
          :items="permissionsCadastroPesquisaSatisfacao"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Relatórios de Pesquisa de Satisfação</div>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col>
            <v-select
              :disabled="permissaoVisualizar || id == 1"
              dense
              v-model="selecionadoRelatorioPesquisaSatisfacao"
              :items="permissionsRelatorioPesquisaSatisfacao"
              label="Selecione o nível de permissão"
              outlined
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            <v-select
              dense
              v-model="selecionadoRelatorioPesquisaSatisfacaoHistorico"
              :items="permissonsRelatorioPesquisaSatisfacaoHistorico"
              label="Selecione o nível de permissão de histórico"
              :disabled="
                selecionadoRelatorioPesquisaSatisfacao ===
                  dictionaryRoles.pesquisaRelatorioTotal.id ||
                  selecionadoRelatorioPesquisaSatisfacao === null ||
                  permissaoVisualizar ||
                  id == 1
              "
              outlined
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Selects Gerais -->
    <v-row no-gutters class="mt-n2">
      <div class="text-h6 mt-n5">Pesquisas de Satisfação</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Pesquisa de Satisfação"
          v-model="selectedPesquisasSatisfacao"
          :items="pesquisasSatisfacao"
          multiple
          class="mt-2"
          :disabled="
            (selecionadoCadastroPesquisaSatisfacao !==
              dictionaryRoles.pesquisaCadastroVisualizarCondicionado.id &&
              selecionadoCadastroPesquisaSatisfacao !==
                dictionaryRoles.pesquisaCadastroEditarCondicionado.id &&
              selecionadoRelatorioPesquisaSatisfacao !==
                dictionaryRoles.pesquisaRelatorioVisualizarCondicionado.id &&
              selecionadoRelatorioPesquisaSatisfacao !==
                dictionaryRoles.pesquisaRelatorioOuvirGravacao.id &&
              selecionadoRelatorioPesquisaSatisfacaoHistorico !==
                dictionaryRoles.pesquisaRelatorioHistorico.id &&
              selecionadoRelatorioPesquisaSatisfacaoHistorico !==
                dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.id) ||
              (selecionadoCadastroPesquisaSatisfacao ===
                dictionaryRoles.pesquisaCadastroTotal.id &&
                selecionadoRelatorioPesquisaSatisfacao ===
                  dictionaryRoles.pesquisaRelatorioTotal.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption">
                (+{{ selectedPesquisasSatisfacao.length - 1 }})
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="togglePesquisas">
              <v-list-item-action>
                <v-icon
                  :color="
                    selectedPesquisasSatisfacao.length > 0
                      ? 'indigo darken-4'
                      : ''
                  "
                >
                  {{ iconPesquisas }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Tags das Pesquisas</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Tags Pesquisa de Satisfação"
          v-model="selectedTags"
          :items="tags"
          multiple
          class="mt-2"
          :disabled="
            (selecionadoCadastroPesquisaSatisfacao !==
              dictionaryRoles.pesquisaCadastroVisualizarCondicionado.id &&
              selecionadoCadastroPesquisaSatisfacao !==
                dictionaryRoles.pesquisaCadastroEditarCondicionado.id &&
              selecionadoRelatorioPesquisaSatisfacao !==
                dictionaryRoles.pesquisaRelatorioVisualizarCondicionado.id &&
              selecionadoRelatorioPesquisaSatisfacao !==
                dictionaryRoles.pesquisaRelatorioOuvirGravacao.id &&
              selecionadoRelatorioPesquisaSatisfacaoHistorico !==
                dictionaryRoles.pesquisaRelatorioHistorico.id &&
              selecionadoRelatorioPesquisaSatisfacaoHistorico !==
                dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.id) ||
              (selecionadoCadastroPesquisaSatisfacao ===
                dictionaryRoles.pesquisaCadastroTotal.id &&
                selecionadoRelatorioPesquisaSatisfacao ===
                  dictionaryRoles.pesquisaRelatorioTotal.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption"> (+{{ selectedTags.length - 1 }}) </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleTAGsPesquisa">
              <v-list-item-action>
                <v-icon
                  :color="selectedTags.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ iconTAGsPesquisa }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { registerVuexModule } from "@/utils/vuexUtils";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { addAndRemovePermissions } from "../_utils/addAndRemovePermissions";
import { dictionaryRoles } from "../_utils/dictionaryRoles";

import roleStore from "../_store";

export default {
  data: () => ({
    dictionaryRoles: dictionaryRoles,
    permissaoVisualizar: false,
    initPermissoes: false,
    // Select Pesquisas de Satisfação
    pesquisasSatisfacao: [],
    selectedPesquisasSatisfacao: [],
    initiatedPesquisaSatisfacao: false,
    // Select TAGs
    tags: [],
    selectedTags: [],
    initiatedTags: false,
    // Cadastro de pesquisa de satisfação
    permissionsCadastroPesquisaSatisfacao: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.pesquisaCadastroVisualizarCondicionado.description,
        value: dictionaryRoles.pesquisaCadastroVisualizarCondicionado.id,
      },
      {
        text: dictionaryRoles.pesquisaCadastroEditarCondicionado.description,
        value: dictionaryRoles.pesquisaCadastroEditarCondicionado.id,
      },
      {
        text: dictionaryRoles.pesquisaCadastroTotal.description,
        value: dictionaryRoles.pesquisaCadastroTotal.id,
      },
    ],
    selecionadoCadastroPesquisaSatisfacao: null,
    // Relatórios de pesquisa de satisfação
    permissionsRelatorioPesquisaSatisfacao: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.pesquisaRelatorioVisualizarCondicionado.description,
        value: dictionaryRoles.pesquisaRelatorioVisualizarCondicionado.id,
      },
      {
        text: dictionaryRoles.pesquisaRelatorioOuvirGravacao.description,
        value: dictionaryRoles.pesquisaRelatorioOuvirGravacao.id,
      },
      {
        text: dictionaryRoles.pesquisaRelatorioTotal.description,
        value: dictionaryRoles.pesquisaRelatorioTotal.id,
      },
    ],
    selecionadoRelatorioPesquisaSatisfacao: null,
    // Relatórios de pesquisa de satisfação - Histórico
    permissonsRelatorioPesquisaSatisfacaoHistorico: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.pesquisaRelatorioHistorico.description,
        value: dictionaryRoles.pesquisaRelatorioHistorico.id,
      },
      {
        text:
          dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.description,
        value: dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.id,
      },
    ],
    selecionadoRelatorioPesquisaSatisfacaoHistorico: null,
  }),
  computed: {
    ...mapGetters("moduloPABXStepStore", [
      "getTags",
      "getPesquisasSatisfacao",
      "getSelectedTagsPesquisaSatisfacao",
      "getSelectedPesquisasSatisfacao",
      "getPermissoes",
    ]),

    todasTAGsPesquisaSelecionadas() {
      return this.selectedTags.length === this.tags.length;
    },
    algumasTAGsPesquisaSelecionadas() {
      return (
        this.selectedTags.length > 0 && !this.todasTAGsPesquisaSelecionadas
      );
    },
    iconTAGsPesquisa() {
      if (this.todasTAGsPesquisaSelecionadas) return "mdi-close-box";
      if (this.algumasTAGsPesquisaSelecionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todasPesquisasSelecionadas() {
      return (
        this.selectedPesquisasSatisfacao.length ===
        this.pesquisasSatisfacao.length
      );
    },
    algumasPesquisasSelecionadas() {
      return (
        this.selectedPesquisasSatisfacao.length > 0 &&
        !this.todasPesquisasSelecionadas
      );
    },
    iconPesquisas() {
      if (this.todasPesquisasSelecionadas) return "mdi-close-box";
      if (this.algumasPesquisasSelecionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  async created() {
    this.initPermissoes = false;
    registerVuexModule(this.$store, "moduloPABXStepStore", roleStore);

    await Promise.all([this.listAllTags(), this.listAllPesquisasSatisfacao()]);

    this.tags = this.getTags.map((tag) => ({
      text: tag.description,
      value: tag._id,
    }));
    this.pesquisasSatisfacao = this.getPesquisasSatisfacao.map((pesquisa) => ({
      text: pesquisa.description,
      value: pesquisa._id,
    }));

    this.selectedTags = this.getSelectedTagsPesquisaSatisfacao;
    this.selectedPesquisasSatisfacao = this.getSelectedPesquisasSatisfacao;

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "listAllTags",
      "setSelectedTagsPesquisaSatisfacao",
      "listAllPesquisasSatisfacao",
      "setSelectedPesquisasSatisfacao",
      "addPermissionsID",
      "deletePermissionsID",
    ]),
    ...obtainUserPermissions,
    ...addAndRemovePermissions,

    togglePesquisas() {
      this.$nextTick(() => {
        if (this.todasPesquisasSelecionadas) {
          this.selectedPesquisasSatisfacao.splice(0);
        } else {
          this.selectedPesquisasSatisfacao.splice(0);
          this.selectedPesquisasSatisfacao = this.pesquisasSatisfacao.map(
            (pesquisa) => pesquisa.value
          );
        }
      });
    },
    toggleTAGsPesquisa() {
      this.$nextTick(() => {
        if (this.todasTAGsPesquisaSelecionadas) {
          this.selectedTags.splice(0);
        } else {
          this.selectedTags.splice(0);
          this.selectedTags = this.tags.map((tag) => tag.value);
        }
      });
    },
  },

  watch: {
    selectedTags: {
      deep: true,
      async handler() {
        await this.setSelectedTagsPesquisaSatisfacao(this.selectedTags);
      },
    },

    selectedPesquisasSatisfacao: {
      deep: true,
      async handler() {
        await this.setSelectedPesquisasSatisfacao(
          this.selectedPesquisasSatisfacao
        );
      },
    },
    getSelectedTagsPesquisaSatisfacao: {
      deep: true,
      handler() {
        if (!this.initiatedTags) {
          this.selectedTags = [...this.getSelectedTagsPesquisaSatisfacao];
          this.initiatedTags = true;
        }
      },
    },
    getSelectedPesquisasSatisfacao: {
      deep: true,
      handler() {
        if (!this.initiatedPesquisaSatisfacao) {
          this.selectedPesquisasSatisfacao = [
            ...this.getSelectedPesquisasSatisfacao,
          ];
          this.initiatedPesquisaSatisfacao = true;
        }
      },
    },
    // Monitora permissoes
    getPermissoes: {
      deep: true,
      handler(newValue) {
        if (!this.initPermissoes) {
          this.initPermissoes = true;
          // Cadastro de Pesquisa de Satisfação
          if (
            newValue.includes(
              dictionaryRoles.pesquisaCadastroVisualizarCondicionado.id
            )
          ) {
            this.selecionadoCadastroPesquisaSatisfacao =
              dictionaryRoles.pesquisaCadastroVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.pesquisaCadastroEditarCondicionado.id
            )
          ) {
            this.selecionadoCadastroPesquisaSatisfacao =
              dictionaryRoles.pesquisaCadastroEditarCondicionado.id;
          } else if (
            newValue.includes(dictionaryRoles.pesquisaCadastroTotal.id)
          ) {
            this.selecionadoCadastroPesquisaSatisfacao =
              dictionaryRoles.pesquisaCadastroTotal.id;
          }
          // Relatórios de Pesquisa de Satisfação
          if (
            newValue.includes(
              dictionaryRoles.pesquisaRelatorioVisualizarCondicionado.id
            )
          ) {
            this.selecionadoRelatorioPesquisaSatisfacao =
              dictionaryRoles.pesquisaRelatorioVisualizarCondicionado.id;
          } else if (
            newValue.includes(dictionaryRoles.pesquisaRelatorioOuvirGravacao.id)
          ) {
            this.selecionadoRelatorioPesquisaSatisfacao =
              dictionaryRoles.pesquisaRelatorioOuvirGravacao.id;
          } else if (
            newValue.includes(dictionaryRoles.pesquisaRelatorioTotal.id)
          ) {
            this.selecionadoRelatorioPesquisaSatisfacao =
              dictionaryRoles.pesquisaRelatorioTotal.id;
          }
          // Relatórios de Pesquisa de Satisfação - Histórico
          if (
            newValue.includes(dictionaryRoles.pesquisaRelatorioHistorico.id)
          ) {
            this.selecionadoRelatorioPesquisaSatisfacaoHistorico =
              dictionaryRoles.pesquisaRelatorioHistorico.id;
          } else if (
            newValue.includes(
              dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.id
            )
          ) {
            this.selecionadoRelatorioPesquisaSatisfacaoHistorico =
              dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.id;
          }
        }
      },
    },
    //Monitora Selects
    selecionadoCadastroPesquisaSatisfacao: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioPesquisaSatisfacao: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue === dictionaryRoles.pesquisaRelatorioTotal.id) {
          this.selecionadoRelatorioPesquisaSatisfacaoHistorico =
            dictionaryRoles.pesquisaRelatorioOuvirGravacaoHistorico.id;
        } else if (newValue === null) {
          this.selecionadoRelatorioPesquisaSatisfacaoHistorico = null;
        }
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioPesquisaSatisfacaoHistorico: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
  },
};
</script>
